export const environment = {
  production: true,
  useHash: false,
  inDev: false,
  qa: true,
  aws: {
    cognito: {
      UserPoolId: "eu-west-1_7yLGARxB0",
      ClientId: "67djl61tm5lbgo32vtgjvtpqmu",
    },
    iot: {
      IdentityPoolId: "eu-west-1:7f4d4c03-25d4-422d-ad0a-d999df49cf02",
      Region: "eu-west-1",
      Login: "cognito-idp.eu-west-1.amazonaws.com/eu-west-1_7yLGARxB0",
      Connection: {
        protocol: "wss",
        host: "a3r5myxpoijri1-ats.iot.eu-west-1.amazonaws.com",
        port: 443,
      },
    },
  },
  uiApi: {
    url: "https://uiapi.edpredy-qa.edpredy.com",
  },
  api: {
    url: "https://redy.edp.pt",
    clientId: "edpportal",
    clientSecret: "15125383-0BFF-4945-B557-D2AC31D1A1AE",
  },
  messagingApi: {
    url: "https://uiapi.edpredy.com",
    apiHeaderKey: "x-api-key",
    apiHeaderValue: "hh7rceai4AnOUroaNDgB9NhuUfUJUP33mkdo2Yb5",
  },
  analytics: {
    url: "https://redy-analytics.corp.edp.pt:8230/api/v1",
  },
  reports: {
    url: "https://staging.redy-reports.whitesmith.co/",
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts